export default __webpack_public_path__ + "static/media/momo.b84ae28f.png";